import { render, staticRenderFns } from "./benner-box.vue?vue&type=template&id=661187f1&scoped=true"
import script from "./benner-box.vue?vue&type=script&lang=js"
export * from "./benner-box.vue?vue&type=script&lang=js"
import style0 from "./benner-box.vue?vue&type=style&index=0&id=661187f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661187f1",
  null
  
)

export default component.exports